// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"17975fed","988":"30bf5513"}[chunkId] + ".chunk.js";
};